// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  sendLeaveScreenLog: null,
  leavingScreenMergeParameters: ['data'],
})

export const LeavingScreenTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  lastLogDateTime: 0,
  productStepSubmitted: false,
  productStepCompleted: false,
  lastInputFocus: '',
  lastLoggedVersion: '',
})

/* ------------- Reducers ------------- */

const leavingScreenMergeParametersR = (state, { data }) => state.merge(data)

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SEND_LEAVE_SCREEN_LOG]: (state) => state,
  [Types.LEAVING_SCREEN_MERGE_PARAMETERS]: leavingScreenMergeParametersR,
})
